import CIcon from '@coreui/icons-react';
import { CTooltip } from '@coreui/react-pro';

export const MANAGER_SEAT_SHIP_COLUMNS = [
     {
          key: 'id',
          label: 'Seat ID',
          _style: { minWidth: '100px', paddingLeft: '20px' },
     },
     {
          key: 'firstName',
          label: 'First Name',
          _style: { width: '160px' },
     },
     {
          key: 'lastName',
          label: 'Last Name',
          _style: { width: '160px' },
     },
     {
          key: 'email',
          label: 'Email',
          _style: { width: '260px', minWidth: '200px' },
     },
     {
          key: 'trainingGroup',
          label: (
               <span>
                    <span>Training Groups </span>
                    <CTooltip
                         content="Training groups operate as tags, allowing you to organize individuals into groups for tracking and reporting."
                         placement="top"
                    >
                         <CIcon icon="icon-info-cilcle" />
                    </CTooltip>
               </span>
          ),
          _style: { minWidth: '200px' },
     },
     {
          key: 'ship',
          label: 'Ship directly to trainee',
          _style: { width: '110px', textAlign: 'center', lineHeight: '20px' },
          filter: false,
          sorter: false,
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '110px', textAlign: 'center' },
     },
     {
          key: 'options',
          label: 'Action',
          filter: false,
          sorter: false,
          _style: { minWidth: '150px', textAlign: 'center' },
     },
];

export const MANAGER_SEAT_COLUMNS = [
     {
          key: 'id',
          label: 'Seat ID',
          _style: { minWidth: '120px', paddingLeft: '20px' },
     },
     {
          key: 'firstName',
          label: 'First Name',
          _style: { width: '160px' },
     },
     {
          key: 'lastName',
          label: 'Last Name',
          _style: { width: '160px' },
     },
     {
          key: 'email',
          label: 'Email',
          _style: { width: '260px', minWidth: '200px' },
     },
     {
          key: 'trainingGroup',
          label: (
               <span>
                    <span>Training Groups </span>
                    <CTooltip
                         content="Training groups operate as tags, allowing you to organize individuals into groups for tracking and reporting."
                         placement="top"
                    >
                         <CIcon icon="icon-info-cilcle" />
                    </CTooltip>
               </span>
          ),
          _style: { minWidth: '200px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '150px', textAlign: 'center' },
     },
     {
          key: 'options',
          label: 'Action',
          filter: false,
          sorter: false,
          _style: { minWidth: '150px', textAlign: 'center' },
     },
];

export const GROUP_LEADER_REPORT_COLUMNS = [
     {
          key: 'id',
          label: 'Seat ID',
          _style: { minWidth: '100px' },
     },
     {
          key: 'firstName',
          label: 'First Name',
          _style: { width: '160px' },
     },
     {
          key: 'lastName',
          label: 'Last Name',
          _style: { width: '160px' },
     },
     {
          key: 'email',
          label: 'Email',
          _style: { width: '260px', minWidth: '200px' },
     },
     {
          key: 'trainingGroup',
          label: (
               <span>
                    <span>Training Groups </span>
                    <CTooltip
                         content="Training groups operate as tags, allowing you to organize individuals into groups for tracking and reporting."
                         placement="top"
                    >
                         <CIcon icon="icon-info-cilcle" />
                    </CTooltip>
               </span>
          ),
          _style: { width: '210px', minWidth: '210px' },
          filter: false,
          sorter: false,
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '110px', maxWidth: '200px', textAlign: 'center' },
          filter: false,
          sorter: false,
     },
];

export const GROUP_LEADER_LESSON_REPORT_COLUMNS = [
     {
          key: 'id',
          label: 'Seat ID',
          _style: { minWidth: '120px' },
     },
     {
          key: 'firstName',
          label: 'First Name',
          _style: { minWidth: '150px', width: '160px' },
     },
     {
          key: 'lastName',
          label: 'Last Name',
          _style: { minWidth: '150px', width: '160px' },
     },
     {
          key: 'email',
          label: 'Email',
          _style: { width: '260px', minWidth: '220px' },
     },
     {
          key: 'trainingGroup',
          label: (
               <span>
                    <span>Training Groups </span>
                    <CTooltip
                         content="Training groups operate as tags, allowing you to organize individuals into groups for tracking and reporting."
                         placement="top"
                    >
                         <CIcon icon="icon-info-cilcle" />
                    </CTooltip>
               </span>
          ),
          _style: { width: '210px', minWidth: '210px' },
          filter: false,
          sorter: false,
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '120px', maxWidth: '200px', textAlign: 'center' },
          filter: false,
          sorter: false,
     },
     {
          key: 'progress',
          label: 'Lessons Progress',
          _style: { width: '100px', textAlign: 'center', lineHeight: '20px' },
          filter: false,
          sorter: false,
     },
     {
          key: 'dateStartLesson',
          label: 'Date Added',
          _style: { minWidth: '200px', textAlign: 'center', lineHeight: '20px' },
          filter: false,
          sorter: false,
     },
     {
          key: 'dateCompleteLesson',
          label: 'Date Completed',
          _style: { minWidth: '200px', textAlign: 'center', lineHeight: '20px' },
          filter: false,
          sorter: false,
     },
];

export const GROUP_LEADER_SHIP_REPORT_COLUMNS = [
     {
          key: 'id',
          label: 'Seat ID',
          _style: { minWidth: '100px' },
     },
     {
          key: 'firstName',
          label: 'First Name',
          _style: { width: '160px' },
     },
     {
          key: 'lastName',
          label: 'Last Name',
          _style: { width: '160px' },
     },
     {
          key: 'email',
          label: 'Email',
          _style: { width: '220px', minWidth: '180px' },
     },
     {
          key: 'trainingGroup',
          label: (
               <span>
                    <span>Training Groups </span>
                    <CTooltip
                         content="Training groups operate as tags, allowing you to organize individuals into groups for tracking and reporting."
                         placement="top"
                    >
                         <CIcon icon="icon-info-cilcle" />
                    </CTooltip>
               </span>
          ),
          _style: { width: '210px', minWidth: '210px' },
          filter: false,
          sorter: false,
     },
     {
          key: 'ship',
          label: 'Ship directly to trainee',
          _style: { width: '110px', textAlign: 'center', lineHeight: '20px' },
          filter: false,
          sorter: false,
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '110px', maxWidth: '200px', textAlign: 'center' },
          filter: false,
          sorter: false,
     },
];

export const GROUP_LEADER_LINK_REPORT_COLUMNS = [
     {
          key: 'id',
          label: 'Seat ID',
          _style: { minWidth: '100px' },
     },
     {
          key: 'linkSelfId',
          label: 'Link ID',
          _style: { minWidth: '110px' },
     },
     {
          key: 'firstName',
          label: 'First Name',
          _style: { width: '160px' },
     },
     {
          key: 'lastName',
          label: 'Last Name',
          _style: { width: '160px' },
     },
     {
          key: 'email',
          label: 'Email',
          _style: { width: '220px', minWidth: '180px' },
     },
     {
          key: 'trainingGroup',
          label: (
               <span>
                    <span>Training Groups </span>
                    <CTooltip
                         content="Training groups operate as tags, allowing you to organize individuals into groups for tracking and reporting."
                         placement="top"
                    >
                         <CIcon icon="icon-info-cilcle" />
                    </CTooltip>
               </span>
          ),
          _style: { width: '210px', minWidth: '210px' },
          filter: false,
          sorter: false,
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '110px', maxWidth: '200px', textAlign: 'center' },
          filter: false,
          sorter: false,
     },
];
